import { API } from "../../../cache";

async function apiJson(url, opts = {}) {
  const res = await fetch(url, { credentials: "include", ...opts });
  let data = null;
  try { data = await res.json(); } catch { data = null; }
  if (!res.ok) {
    const detail = data?.detail || data?.message || "Request failed";
    const err = new Error(detail);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

export function listFilterTemplates(module) {
  return apiJson(`${API}/filter-templates?module=${encodeURIComponent(module)}`);
}

export function saveFilterTemplate({ module, name, filter_def, filter_mode = "all" }) {
  return apiJson(`${API}/filter-templates`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ module, name, filter_def, filter_mode }),
  });
}

export function updateFilterTemplate(id, patch) {
  return apiJson(`${API}/filter-templates/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
}

export async function deleteFilterTemplate(id) {
  const res = await fetch(`${API}/filter-templates/${id}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok && res.status !== 204) {
    let data = null;
    try { data = await res.json(); } catch { data = null; }
    const err = new Error(data?.detail || "Failed to delete filter template");
    err.status = res.status;
    throw err;
  }
  return true;
}
